export type OnboardCountPrintFilters = {
  vesselId?: string;
};

export function onboardCountPrintPath(filters: OnboardCountPrintFilters = {}): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  const s = qs.toString();
  return `/crew/statistics/onboard/print${s ? `?${s}` : ''}`;
}

export function onboardCountListApiUrl(params: URLSearchParams): string {
  const today = new Date().toISOString().slice(0, 10);
  const qs = new URLSearchParams({
    withinDays: '90',
    periodFrom: today,
    periodTo: today,
  });
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/statistics?${qs.toString()}`;
}

export function onboardCountBackPath(): string {
  return '/crew/statistics/onboard';
}
